import { Text } from 'grommet';
import styled from 'styled-components';

export const DataText = styled(Text)`
  font-size: 14px;
  font-family: 'PT Sans', sans-serif;
  font-weight: 700;
`;

export const OuterBoxx = styled.div`
  text-align: center;
`;

export const BigBoldText = styled.p`
  font-size: 24px;
  font-weight: 700;
  margin-top: 45px;
`;

export const SmallText = styled.p`
  font-size: 18px;
  margin-top: 15px;
  margin-bottom: 30px;
`;

export const ErrorBox = styled.div`
  display: flex;
  justify-content: center;
`;

export const Data = styled.li`
  display: flex;
  justify-content: center;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 10px;
  background-color: #f5f7fa;
  word-break: break-word;
  width: 100%;
`;

export const OuterBox = styled.div`
  &:hover {
    box-shadow: inset 4px 0 0 #9325b2;
  }
`;

export const DataGroup = styled.section`
  display: flex;
  flex-direction: row;
  padding: 10px 0;
`;

export const TextData = styled.li`
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    height: 100%;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  color: #041e41;
  font-family: 'PT Sans', sans-serif;
  font-size: 16px;
  font-weight: 400;
  list-style: none;
  margin: 0;
  padding: 10px;
  word-break: break-all;
  width: 100%;
`;
